import { css } from 'linaria';

export const addReviewsLabel = css`
  color: var(--text-secondary);

  &:active {
    color: var(--text-primary);
  }

  @media (hover: hover) and (min-width: 1024px) {
    &:hover {
      color: var(--text-primary);
    }
  }
`;
